angular.module("digitalLeasing.module").component("additionalRegisteredInfo", {
    templateUrl: "ng/components/digitalLeasing/goodManagement/additionalRegisteredInfo/additionalRegisteredInfo.view.html",
    bindings: {
        model: "=", //elementToAdd
        marcaVeicolo: "=",
        preventivo: "=",
        financialCustomer: "=",
        viewIndex: "=",
        registeredIsOk: "&",
        registeredIsNotOk: "&",
        stato: "<",
        allestimento: "<",
        allestimentoObj: "<",
        initialTabIndex: "=",
        cdu: "<"
    },

    controllerAs: "addRegisteredInfoCtrl",
    controller: AdditionalRegisteredInfoController
});

function AdditionalRegisteredInfoController(
    $financialApiService,
    $rootScope,
    $scope,
    $typeDomainService,
    $timeout
) {
    var self = this;

    var initProvince = function () {
        self.supportModel.provinceType = $rootScope.comuniMap
            .map(function (comune) {
                return comune.sigla;
            })
            .filter(function (siglaComune) {
                return siglaComune != "";
            })
            .sort()
            .reduce(function (result, nextItem) {
                return result.includes(nextItem) ? result : result.concat(nextItem);
            }, []);
    };

    self.$onInit = function () {
        self.supportModel = {
            brandType: [],
            provinceType: [],
            modelsType: [],
            error: {
                quotaEsente: false
            },
            isM12: true,
            fieldsIsRequired: false,
            marcaSelected: [],
            modelloSelected: [],
            hideFields: false,
            testQuotaEsente: false,
            oggettoModello: {
                id: "",
                description: ""
            },
            initialIndex: 0,
            categorieAllestimento: [],
            marcaAllestimento: false,
            modelloAllestimento: false,
            errorTargaAll: false,
            errorModelloAll: false
        }

        getAllestimenti();

        self.supportModel.initialIndex = self.initialTabIndex || 0;

        self.supportModel.isM12 = getWizardMap(self.viewIndex) == "M12" ? true : false;

        if (!self.model.targato.marcaVeicolo.description) {
            self.supportModel.marcaSelected = Object.assign({}, self.preventivo.prodotto.bene.marcaVeicolo);
            self.supportModel.modelloSelected = self.preventivo.prodotto.bene.marcaVeicolo.modello.length > 0 ?
                Object.assign({}, self.preventivo.prodotto.bene.marcaVeicolo.modello[0]) : [];
            self.model.targato.marcaVeicolo = self.supportModel.marcaSelected;
            self.model.targato.marcaVeicolo.modello = self.supportModel.marcaSelected.modello;
        } else {
            self.supportModel.marcaSelected = Object.assign({}, self.model.targato.marcaVeicolo);
            self.supportModel.modelloSelected = Object.assign({}, self.model.targato.marcaVeicolo.modello[0]);

            $timeout(function () {
                checkAllestimento("marca", self.supportModel.marcaSelected.id);
                checkAllestimento("modello", self.model.targato.marcaVeicolo.modello[0].id);
            }, 1000);
        }

        self.model.targato.quotaEsente = self.model.targato.quotaEsente != null && self.model.targato.quotaEsente != "" ||
            self.model.targato.quotaEsente == 0 ? self.model.targato.quotaEsente : self.preventivo.prodotto.quotaEsente;
        self.model.targato.provinciaImmatricolazione =
            self.model.targato.provinciaImmatricolazione ? self.model.targato.provinciaImmatricolazione : self.financialCustomer.metadata.riUserG.sedeLegale.provincia;

        if (self.model.stato === "" && self.preventivo.prodotto.bene.stato) {
            self.model.stato = Object.assign({}, self.preventivo.prodotto.bene.stato);
        }

        if (self.model.stato === "LBL_GOOD_STATE_NEW") {
            self.supportModel.fieldsIsRequired = false;
        } else if (self.model.stato != "LBL_GOOD_STATE_NEW" && self.supportModel.marcaAllestimento) {
            self.supportModel.fieldsIsRequired = false;
        } else if (self.model.stato != "LBL_GOOD_STATE_NEW") {
            self.supportModel.fieldsIsRequired = true;
        }

        getListofBrand(self.preventivo.prodotto.id);
        initProvince();
        checkValidation();
    };

    self.$onChanges = function (changed) {
        if (self.supportModel) {
            if (self.model.stato === "LBL_GOOD_STATE_NEW") {
                self.supportModel.fieldsIsRequired = false;
            } else if (self.model.stato != "LBL_GOOD_STATE_NEW" && self.supportModel.marcaAllestimento) {
                self.supportModel.fieldsIsRequired = false;
            } else if (self.model.stato != "LBL_GOOD_STATE_NEW") {
                self.supportModel.fieldsIsRequired = true;
            }

            if (changed.cdu && typeof changed.cdu.currentValue != undefined) {
                if (self.allestimentoObj && self.allestimento) {
                    if (self.model.targato && self.model.targato.marcaVeicolo && self.model.targato.marcaVeicolo.id && self.allestimentoObj[0].marca != self.model.targato.marcaVeicolo.id) {
                        self.supportModel.errorTargaAll = true;
                    } else {
                        self.supportModel.errorTargaAll = false;
                    }

                    if (self.model.targato.marcaVeicolo.modello[0] != null && self.model.targato.marcaVeicolo.modello[0].id != self.allestimentoObj[1].modello) {
                        self.supportModel.errorModelloAll = true;
                    } else {
                        self.supportModel.errorModelloAll = false;
                    }

                    self.model.targato.marcaVeicolo.description = self.allestimentoObj[0].marca;
                    self.model.targato.marcaVeicolo.id = self.allestimentoObj[0].marca;
                    self.model.targato.marcaVeicolo.modello = [];
                    self.model.targato.marcaVeicolo.modello.push({ id: self.allestimentoObj[1].modello, description: self.allestimentoObj[1].modello });

                    self.supportModel.marcaSelected = Object.assign({}, self.model.targato.marcaVeicolo);
                    self.supportModel.modelloSelected = Object.assign({}, self.model.targato.marcaVeicolo.modello[0]);

                } else {
                    if (self.model && self.model.targato && self.model.targato.marcaVeicolo && self.model.targato.marcaVeicolo.modello && self.model.targato.marcaVeicolo.modello[0] && !self.model.targato.marcaVeicolo.id && !self.model.targato.marcaVeicolo.modello[0].id) {
                        self.supportModel.marcaSelected = Object.assign({}, self.preventivo.prodotto.bene.marcaVeicolo);
                        self.supportModel.modelloSelected = self.preventivo.prodotto.bene.marcaVeicolo.modello[0] != null ?
                            Object.assign({}, self.preventivo.prodotto.bene.marcaVeicolo.modello[0]) : [];
                        self.model.targato.marcaVeicolo = self.supportModel.marcaSelected;
                        if (self.supportModel.marcaSelected.modello[0] != null) {
                            self.model.targato.marcaVeicolo.modello.push(self.supportModel.marcaSelected.modello[0]);
                        }

                    }

                }

                checkAllestimento("marca", self.model.targato.marcaVeicolo.id);
                checkAllestimento("modello", self.supportModel.modelloSelected.id);
            }
            checkValidation();
        }
    };

    self.handleChange = function (property, value) {
        switch (property) {
            case "marcaVeicolo":
                self.supportModel.marcaSelected = value;
                self.model.targato.marcaVeicolo = self.supportModel.marcaSelected;
                self.supportModel.modelloSelected = [];
                self.supportModel.modelsType = value.modello;
                checkAllestimento("marca", self.model.targato.marcaVeicolo.id);
                break;
            case "quotaEsente":
                if (parseInt(value) > parseInt(self.model.importoCespite)) {
                    self.supportModel.error.quotaEsente = true;
                } else {
                    self.supportModel.error.quotaEsente = false;
                    self.model.targato[property] = value;
                }
                break;
            case "modello":
                self.model.targato.marcaVeicolo.modello = [];
                self.model.targato.marcaVeicolo.modello.push(value);
                checkAllestimento("modello", self.model.targato.marcaVeicolo.modello[0].id);
                break;
            default:
                self.model.targato[property] = value;
                break;
        }

        checkValidation();
    }

    var getListofBrand = function (codProdotto) {
        $financialApiService
            .getlistOfCarBrands(codProdotto)
            .then(function (brandsList) {
                self.supportModel.brandType = brandsList;
                self.findModel(self.model.targato.marcaVeicolo);
            })
            .catch(function (error) {
                console.error(error);
            });
    }

    self.findModel = function (brand) {
        if (brand) {
            var listOfModel = self.supportModel.brandType.find(function (element) {
                return element.id === brand.id;
            });
            self.supportModel.modelsType = listOfModel && listOfModel.modello;
        }
        checkValidation();
    }

    var checkValidation = function () {
        var testMarcaEModello = false;
        var testTargaETelaio = false;

        testMarcaEModello = self.model.targato.provinciaImmatricolazione &&
            self.supportModel.marcaSelected.id && self.supportModel.modelloSelected.id &&
            !self.supportModel.errorTargaAll && !self.supportModel.errorModelloAll

        if (self.preventivo.prodotto.id !== "AVI") {
            self.supportModel.testQuotaEsente = !self.supportModel.error.quotaEsente &&
                (self.model.targato.quotaEsente != null && self.model.targato.quotaEsente != "" || self.model.targato.quotaEsente == 0);
        } else {
            self.supportModel.testQuotaEsente = self.model.targato.quotaEsente.toString() != null && self.model.targato.quotaEsente.toString() != "";
        }

        if (self.supportModel.fieldsIsRequired && self.supportModel.modelloSelected.id != "AUTALLESTI") {
            testTargaETelaio = self.model.targato.telaioVeicolo && self.model.targato.targaVeicolo;
        } else if (self.supportModel.modelloSelected.id === "AUTALLESTI") {
            testTargaETelaio = self.model.targato.telaioVeicolo &&
                self.model.targato.targaVeicolo ? $scope.formRegisteredInfo && $scope.formRegisteredInfo.$valid : true;
        } else {
            testTargaETelaio = $scope.formRegisteredInfo && $scope.formRegisteredInfo.$valid;
        }

        if (testMarcaEModello && testTargaETelaio && self.supportModel.testQuotaEsente) {
            self.registeredIsOk();
        } else {
            self.registeredIsNotOk();
        }
    }

    var getWizardMap = function (viewIndex) {
        return $rootScope.wizardMap
            .find(function (element) {
                return element.index == viewIndex
            }).viewName
    }

    var checkAllestimento = function (type, value) {
        if (self.supportModel) {

            self.supportModel.categorieAllestimento.forEach(function (element) {
                if (element === value) {
                    type === "marca" ? self.supportModel.marcaAllestimento = true : self.supportModel.modelloAllestimento = true;
                } else {
                    type === "marca" ? self.supportModel.marcaAllestimento = false : self.supportModel.modelloAllestimento = false;
                }
            });

            if (self.model.stato === "LBL_GOOD_STATE_NEW") {
                self.supportModel.fieldsIsRequired = false;
            } else if (self.model.stato != "LBL_GOOD_STATE_NEW" && self.supportModel.marcaAllestimento) {
                self.supportModel.fieldsIsRequired = false;
            } else if (self.model.stato != "LBL_GOOD_STATE_NEW") {
                self.supportModel.fieldsIsRequired = true;
            }

            self.supportModel.errorTargaAll = false;
            self.supportModel.errorModelloAll = false;
            if (self.allestimentoObj && self.allestimento && self.model.codiceCDU == "AVC00004") {
                if (self.allestimentoObj[0].marca != self.model.targato.marcaVeicolo.id) {
                    self.supportModel.errorTargaAll = true;
                } else {
                    self.supportModel.errorTargaAll = false;
                }

                if (self.allestimentoObj[1].modello != self.model.targato.marcaVeicolo.modello[0].id) {
                    self.supportModel.errorModelloAll = true;
                } else {
                    self.supportModel.errorModelloAll = false;
                }
            }

            checkValidation();
        }
    }

    var getAllestimenti = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_INFO_ASSET", "CATEGORIA_ALLESTIMENTO").then(function (response) {
            response.domainList.forEach(function (element) {
                self.supportModel.categorieAllestimento.push(element.name);
            })
        });
    }
}
